import { FrontendProduct } from "@redotech/redo-model/agents/support-agents/frontend-product";

type FrontendProductVariant = FrontendProduct["variants"][number];

/**
 * Orders variants by their attributes in sequence (e.g. size, then flavor) so
 * the variant dropdown reads sensibly. Comparison is numeric-aware so "4 oz"
 * sorts before "8 oz" before "10 oz" rather than lexically.
 */
export function compareVariantsByAttributes(
  a: FrontendProductVariant,
  b: FrontendProductVariant,
): number {
  const aAttrs = a.attributes ?? [];
  const bAttrs = b.attributes ?? [];
  const length = Math.max(aAttrs.length, bAttrs.length);
  for (let i = 0; i < length; i++) {
    const aVal = aAttrs[i]?.value;
    const bVal = bAttrs[i]?.value;
    if (aVal == null && bVal == null) {
      continue;
    }
    if (aVal == null) {
      return -1;
    }
    if (bVal == null) {
      return 1;
    }
    const comparison = String(aVal).localeCompare(String(bVal), undefined, {
      numeric: true,
      sensitivity: "base",
    });
    if (comparison !== 0) {
      return comparison;
    }
  }
  return 0;
}

/**
 * Orders variants by their title string, numeric-aware, for variant types that
 * lack structured attributes (e.g. Shopify storefront { id, title } variants).
 */
export function compareVariantsByTitle<T extends { title: string }>(
  a: T,
  b: T,
): number {
  return String(a.title).localeCompare(String(b.title), undefined, {
    numeric: true,
    sensitivity: "base",
  });
}
